<div class="col-md-12 main-heading">
  <div class="d-flex">
    <a routerLink="/index">
      <div class="icon-heading"><img src="assets/images/pages-icon/backbtn.png" class="img-responsive"> </div>
    </a>
    <div class="caption-heading">ANPR Video Streaming</div>
  </div>
</div>
<div class="col-md-12 pagecustom">
  <div class="page-wrapper">
    <div class="row main-container boxscroll">
      <div class="block-section width-xs-metro">
        <div class="heading-m">
          <div class="caption">
            <img src="assets/images/pages-icon/rates.png">Devices
          </div>
          <div class="icon buttons">
          </div>
        </div>
        <app-side-list [itemList]="deviceList" [showItem]="'DEVICE_NAME'" [searchItem]="'DEVICE_NAME'" [showColor]="false"></app-side-list>
      </div>
      <div class="block-section width-lg-metro targetDiv " [@widthGrow]="state">
        <div class="heading-m">
        </div>
        <div class="list-sidebar">
          <div class="card">
            <div class="card-body">
              <div style="width:100%; height: 150px; margin-bottom: 30px;"></div>
            </div>
            <div class="card-body" style="border: solid 1px gray; margin-top: 10px;">
              <div class="icon-heading" style="float: left; margin-left: 8px;"><img src="assets/images/pages-icon/media-play.png" class="img-responsive"> </div>
              <div class="icon-heading" style="float: left; margin-left: 8px;"><img src="assets/images/pages-icon/media-stop.png" class="img-responsive"> </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
